<template>
  <div id="guarantee-page" class="min-vh-100 d-flex flex-column">
    <main class="flex-grow-1 bg-light">
      <div class="container oversized-container px-3 py-5 py-md-5" style="max-width: 56rem;">
        <div class="text-center mb-5">
          <i class="fa-solid fa-shield-halved txt-cprimary mb-4 d-block" style="font-size: 4rem;"></i>
          <h1 class="display-4 font-weight-bold mb-4">Quality Guarantee</h1>
          <p class="lead text-muted">
            At DEC Industries, we stand behind every part we sell with comprehensive warranty coverage
          </p>
        </div>

        <div class="row mb-5">
          <div class="col-12 col-md-6 mb-4">
            <div class="card border h-100">
              <div class="card-body p-4">
                <i class="fa-solid fa-circle-check txt-cprimary mb-3 d-block" style="font-size: 2.5rem;"></i>
                <h2 class="h5 font-weight-bold mb-3">12-Month Warranty</h2>
                <p class="text-muted mb-0">
                  All our engine parts come with a comprehensive 12-month warranty covering manufacturing defects and
                  material failures under normal operating conditions.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 mb-4">
            <div class="card border h-100">
              <div class="card-body p-4">
                <i class="fa-solid fa-clock txt-cprimary mb-3 d-block" style="font-size: 2.5rem;"></i>
                <h2 class="h5 font-weight-bold mb-3">30-Day Returns</h2>
                <p class="text-muted mb-0">
                  Not satisfied with your purchase? Return unused parts within 30 days for a full refund. No questions
                  asked, hassle-free process.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 mb-4">
            <div class="card border h-100">
              <div class="card-body p-4">
                <i class="fa-solid fa-file-lines txt-cprimary mb-3 d-block" style="font-size: 2.5rem;"></i>
                <h2 class="h5 font-weight-bold mb-3">Certified Quality</h2>
                <p class="text-muted mb-0">
                  Every part is thoroughly inspected and tested to meet or exceed OEM specifications. We only source from
                  trusted manufacturers.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 mb-4">
            <div class="card border h-100">
              <div class="card-body p-4">
                <i class="fa-solid fa-shield-halved txt-cprimary mb-3 d-block" style="font-size: 2.5rem;"></i>
                <h2 class="h5 font-weight-bold mb-3">Technical Support</h2>
                <p class="text-muted mb-0">
                  Our expert team is available to assist with installation guidance, troubleshooting, and any technical
                  questions throughout the warranty period.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white border rounded p-4 p-md-5">
          <h2 class="h4 font-weight-bold mb-4">Warranty Terms</h2>
          <ul class="list-unstyled text-muted mb-0">
            <li class="d-flex align-items-start mb-3">
              <span class="txt-cprimary mr-2 mt-1">•</span>
              <span>Warranty coverage begins from the date of purchase</span>
            </li>
            <li class="d-flex align-items-start mb-3">
              <span class="txt-cprimary mr-2 mt-1">•</span>
              <span>Parts must be installed by certified mechanics</span>
            </li>
            <li class="d-flex align-items-start mb-3">
              <span class="txt-cprimary mr-2 mt-1">•</span>
              <span>Proof of purchase required for all warranty claims</span>
            </li>
            <li class="d-flex align-items-start mb-3">
              <span class="txt-cprimary mr-2 mt-1">•</span>
              <span>Warranty does not cover misuse, improper installation, or accident damage</span>
            </li>
            <li class="d-flex align-items-start">
              <span class="txt-cprimary mr-2 mt-1">•</span>
              <span>Contact our support team within 48 hours of discovering any defects</span>
            </li>
          </ul>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'GuaranteePage',
}
</script>
